import { TopToolbar, CreateButton, ExportButton, FilterButton } from "react-admin";
import type { Exporter } from "react-admin";
import { i18nProvider } from "../../../i18n";
import jsonExport from "jsonexport/dist";
import { downloadCSV } from "../../../utils/csv";

const EXPORT_FORBIDDEN_KEYS = ["shortId"];

const frontUserStatisticExporter: Exporter = (data, _fetchRelatedRecords, __, resource: string | undefined): void => {
    if (resource == null) {
        return;
    }

    // Remove useless keys
    for (const line of data) {
        if (typeof line !== "object") {
            continue;
        }

        for (const key of Object.keys(line)) {
            if (!EXPORT_FORBIDDEN_KEYS.includes(key)) {
                continue;
            }
            delete line[key];
        }
    }

    // Get headers
    const firstLine = data?.[0];
    const headers = Object.keys(firstLine);

    // Translate headers
    const rename = [];

    for (const headerId of headers) {
        const defaultTranslation = i18nProvider.translate(`resources.${resource}.fields.${headerId}`, { _: headerId });
        rename.push(i18nProvider.translate(`resources.${resource}.exportFields.${headerId}`, { _: defaultTranslation }));
    }

    jsonExport(data, { rowDelimiter: ";", headers, rename }, (_err: unknown, csv: string) => {
        downloadCSV(csv, resource);
    });
};

export function FrontUserStatisticListActions(): JSX.Element {
    return (
        <TopToolbar sx={{ alignItems: "center" }}>
            <CreateButton />
            <ExportButton maxResults={10000} exporter={frontUserStatisticExporter} />
            <FilterButton disableSaveQuery />
        </TopToolbar>
    );
}
